<div class="row section-title">
  <div class="background" *ngIf="!background; else color">
    <h4>{{title}}</h4>
  </div>

  <ng-template #color>
    <div class="background" [style.borderBottomColor]="background">
      <h4>{{title}}</h4>
    </div>
  </ng-template>
</div>